var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"wh-map-select",class:[_vm.props.campaign]},[_c('div',{staticClass:"button"},[_vm._v(_vm._s(_vm.props.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }